enum Sex {
	M = 'M', F = 'F'
}

export default Sex;